import React from 'react';
import {getDate, getJackpot, useStyles} from './helper';

const JackpotItem = ({item}) => {
    const {amount, groups, login, jackpot, event_date} = item
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <span className={classes.date}>{getDate(event_date)}</span>
            <span className={classes.jackpot}>{getJackpot(jackpot)}</span>
            <span>{login} ({groups})</span>
            <span className={classes.fw}>{new Intl.NumberFormat('ru-RU').format(amount ? amount.toFixed(2) : amount)}</span>
        </div>
    )
}

export default JackpotItem;